import React from "react";
import SearchSvg from "../svg/SearchSvg";
import "./search.scss";
const Search = ({ varient }) => {
  return (
    <form className={`search_form ${varient}`}>
      <input
        className="search_field"
        type="text"
        placeholder="Search here..."
      />
      <button className="submit_btn">
        <SearchSvg />
      </button>
    </form>
  );
};
Search.defaultProps = {
  varient: "style1",
};
export default Search;
